/**
 * Outline SVG icon module.
 */
import * as React from "react";
/**
 * Photograph (outline) SVG icon. Generated wrapper that forwards props to the root svg.
 *
 * @param {React.SVGProps<SVGSVGElement>} props SVG element props.
 * @returns {JSX.Element}
 */
const SvgPhotograph = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m34 46 4.586-4.586a2 2 0 0 1 2.828 0L46 46m-2-2 1.586-1.586a2 2 0 0 1 2.828 0L50 44m-6-6h.01M36 50h12a2 2 0 0 0 2-2V36a2 2 0 0 0-2-2H36a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2"
    />
  </svg>
);
export default SvgPhotograph;
